import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  Table,
  Form,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Label,
  Input
} from "reactstrap";

import {
  PanelHeader,
  Statistics,
  Button
} from "components";
import Select from "react-select";
import { validateSpanishId } from "spain-id";
import { Link } from "react-router-dom";

import moment from "moment";

const items_per_page_options = [
  {
    label: "10",
    value: 10
  },
  {
    label: "20",
    value: 20
  },
  {
    label: "50",
    value: 50
  },
  {
    label: "100",
    value: 100
  }
];
const result_statuses = [
  {
    label: "Sin reclamar",
    value: 380
  },
  {
    label: "Reclamado",
    value: 381
  },
  {
    label: "Rechazado",
    value: 382
  }
];

class RouletteResults extends React.Component {
  constructor(props) {
    super(props);
    /* //console.log("########## PROPS ###########");
    //console.log(props); */
    this.state = {
      results: null,
      pager: null
    };
    this.onChange = this.onChange.bind(this);
    this.emailChange = this.emailChange.bind(this);
    this.mobileChange = this.mobileChange.bind(this);
    this.validateNumber = this.validateNumber.bind(this);
    this.validatePhoneNumber = this.validatePhoneNumber.bind(this);
    this.validateField = this.validateField.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.fullnameValidate = this.fullnameValidate.bind(this);
    this.buildResultsTable = this.buildResultsTable.bind(this);
    this.searchRouletteResults = this.searchRouletteResults.bind(this);
    this.setRouletteStatus = this.setRouletteStatus.bind(this);
  }
  componentDidMount() {
    this.searchRouletteResults();
  }
  searchRouletteResults(filter) {
    if (!this.state.loadingResults) {
      this.setState({ loadingResults: true });
      if (!filter) {
        // console.log("No hay filtro, buscando resultados con filtro por defecto...", this.state);
        if (this.state.pager) {
          let pager = this.state.pager;
          filter = { ...pager };
        } else {
          filter = {
            query: "",
            page: 1,
            items_per_page: 10
          };
        }
      }
      // filter.page = filter.page - 1;
      this.props.userData.searchRouletteResults(filter).then(result => {
        if (result.ok) {
          let results = result.results;
          let pager = result.pager;
          this.setState({ 
            results: results,
            pager: pager,
            loadingResults: false
          });
          // console.log("Resultados cargados", result);
          // console.log("Pager cargado", pager);
        } else {
          this.setState({
              results: [],
              loadingResults: false
          });
        }
      })
      .catch((error) => {
        // Error 😨
        this.setState({ loadingResults: false });
        console.error("Error al cargar los resultados", error);
        // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
      });
    } else {
      return;
    }
  }
  setRouletteStatus(result_id, status) {
    let settingStatus = this.state.settingStatus;
    if (settingStatus && settingStatus[result_id]) return;
    if (!settingStatus) settingStatus = [];
    settingStatus[result_id] = true;
    this.setState({ settingStatus: settingStatus });

    let request = {
      id: result_id,
      status: status
    };
    // filter.page = filter.page - 1;
    this.props.userData.setRouletteResultStatus(request).then(result => {
      let settingStatus = this.state.settingStatus;
      settingStatus[result_id] = false;

      if (result.ok) {
        let results = this.state.results;
        results[result_id] = result.result;
        this.setState({ 
          results: results,
          settingStatus: settingStatus
        });
      } else {
        this.setState({ settingStatus: settingStatus });
      }
    })
    .catch((error) => {
      // Error 😨
      let settingStatus = this.state.settingStatus;
      settingStatus[result_id] = false;
      this.setState({ settingStatus: settingStatus });
      console.error("Error al editar el estado del resultado", { id: result_id, status: status });
      // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  validateForm() {
    return (
      this.state.selectedInterest &&
      this.validatePhoneNumber(this.state.mobile) &&
      this.emailValidate(this.state.email) &&
      this.fullnameValidate(this.state.name)
    );
  }
  fullnameValidate(value) {
    let result = false;
    if (value) {
      let chunks = value.split(" ");
      // Comprobamos que haya más de 1 palabra
      if (chunks.length > 1) {
        let subresult = true;
        // Comprobamos que cada palabra tenga más de 1 caracter
        chunks.map(current => {
          subresult = current.length > 1 && subresult;
        });
        result = subresult;
      }
    }
    return result;
  }
  onChange(field, value) {
    let state = this.state;
    state[field] = value;
    this.setState(state);
  }
  emailValidate(email) {
    if (!email) return false;
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRex.test(email);
  }
  emailChange(e) {
    let email = e.target.value;
    this.setState({
      email: email
    });
    if (this.emailValidate(email)) {
      this.setState({
        emailState: " has-success"
      });
    } else {
      this.setState({
        emailState: " has-danger"
      });
    }
    this.onChange("email", e.target.value);
  }
  mobileChange(e) {
    let mobile = e.target.value;
    this.setState({
      mobile: mobile
    });
    if (this.validatePhoneNumber(mobile)) {
      this.setState({
        mobileState: " has-success"
      });
    } else {
      this.setState({
        mobileState: " has-danger"
      });
    }
    this.onChange("mobile", mobile);
  }
  validateNumber(e) {
    var numberRex = new RegExp("^[0-9]+$");
    if (numberRex.test(e)) {
      return true;
    } else {
      return false;
    }
  }
  validatePhoneNumber(phoneNumber) {
    let result = false;
    if (this.validateNumber(phoneNumber)) {
      if (phoneNumber.startsWith("6") || phoneNumber.startsWith("7") || phoneNumber.startsWith("8") || phoneNumber.startsWith("9")) {
        if (phoneNumber.length === 9) {
          result = true;
        }
      }
    }
    return result;
  }
  validateField(field, value) {
    let fieldStates = this.state.fieldStates;
    switch (field) {
      case "phoneNumber":
        if (this.validatePhoneNumber(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "movil":
        if (this.validatePhoneNumber(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "ICC":
        if (this.validateICC(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "iban":
        if (this.validateIBAN(value)) {
          fieldStates[field] = "has-success";
          if (this.isNewIBAN(value)) {
            this.props.setCustomerIBAN(this.state.customer.id, value);
            this.setState({ latestValidatedIBAN: value.replace(/ /g, "") });
          }
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "newPassword":
        if (this.validateNewPassword(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "nombre":
        if (this.validateNombre(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "primer_apellido":
        if (this.validateNombre(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "segundo_apellido":
        if (this.validateNombre(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "email":
        var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (emailRex.test(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "nif":
        var regPassport = /^[A-PR-WY][1-9]\d\s?\d{4}[1-9]$/;
        var validPassport = regPassport.test(value);
        if (validateSpanishId(value) || validPassport) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "direccion":
        if (this.validateNombre(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "localidad":
        if (this.validateNombre(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "codigo_postal":
        if (value && value > 0 && value.length === 5) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      default:
    }
    this.setState({ fieldStates: fieldStates });
  }
  buildResultStatus(status, statusSelect) {
    let borderColor = "";
    let statusID = parseInt(status.value);
    switch (statusID) {
      case 380: // Sin reclamar
        borderColor = "#888888";
        break;
      case 381: // Reclamado
        borderColor = "#009879";
        break;
      case 382: // Rechazado
        borderColor = "#CC2127";
        break;
      default:
        borderColor = "#888888";
        break;
    }
    let style = {
      borderColor: borderColor,
      color: borderColor
    };
    return (
      <span className="estado-resultado-premio" style={style}>
        {statusSelect}
      </span>
    );
  }
  buildResultsTable() {
    let results = this.state.results;
    if (!results) {
      return (
        <CardBody className="text-center">
          <div>
            <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando...
          </div>
        </CardBody>
      );
    } else {
      let table = null;
      if (!this.state.loadingResults) {
        table = (
          <Table responsive className="styled-table">
            <thead>
              <tr className="text-primary">
                <th className="text-left">ID</th>
                {/* <th>Fecha</th> */}
                <th className="text-left">Premio</th>
                <th className="text-left">Formulario</th>
                <th className="text-left">Estado</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(results).sort((a,b)=>b-a).map(result_id => {
                let result = results[result_id];
                let isThisSelectedResult = (this.state.showItems === result_id) || (this.state.showNotes === result_id) || (this.state.registerPayment === result_id);
                let isAnySelectedResult = (this.state.showItems !== null) || (this.state.showNotes !== null) || (this.state.registerPayment !== null);

                let settingStatus = this.state.settingStatus;
                let isSettingStatus = false;
                if (settingStatus && settingStatus[result.id]) isSettingStatus = settingStatus[result.id];
                
                let statusSelect = !isSettingStatus ? 
                  <Select
                    className="react-select primary"
                    classNamePrefix="react-select"
                    placeholder="Estado del premio"
                    name="estado_premio"
                    value={result.prize_status}
                    options={result_statuses}
                    onChange={value => {
                      this.setRouletteStatus(result.id, value.value);
                      // console.log("Cambio de estado");
                      // let pager = this.state.pager;
                      // pager.items_per_page = value.value;
                      // this.setState({ pager: pager });
                      // this.searchRouletteResults(pager);
                    }}
                  /> :
                  <div className="resultado-premio-editando-estado">
                    <i className="now-ui-icons arrows-1_refresh-69 spin" /> Editando...
                  </div>;

                let currentTr = (
                  <tr key={result.id} /*className={isThisSelectedResult ? "show-line-items active-row" : (isAnySelectedResult ? "background-row" : "")}*/>
                    <td className="text-left">
                      <span className="roulette-result-id">#{result.id}</span>
                      <span><br /><span className="item-related unpaid-date"><i className="now-ui-icons ui-1_calendar-60" /> {result.date}</span></span>
                    </td>
                    {/* {this.props.showCustomer && <td className="text-center">{currentCustomerLink}</td>} */}
                    <td className="text-left"><span className="roulette-result-prize" style={{backgroundColor: result.result.value.style.backgroundColor, color: result.result.value.style.textColor}}><i className="now-ui-icons shopping_tag-content" /> {result.result.value.option}</span></td>
                    <td className="text-left">
                      {result.fields.map(field => {
                        return (
                          <span
                            key={result.id + "-field-" + field.id}
                            className="roulette-result-form-field"
                          >
                            <span className="field-name">{field.name}</span>
                            <span className="field-value">
                              {typeof field.value === "string"
                                ? field.value
                                : field.value.label}
                            </span>
                          </span>
                        );
                      })}
                    </td>
                    <td className="text-left">
                      {this.buildResultStatus(result.prize_status, statusSelect)}
                    </td>
                  </tr>
                );
                return currentTr;
              })}
            </tbody>
          </Table>
        );
      } else {
        table = (
          <CardBody className="text-center">
            <div>
              <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando...
            </div>
          </CardBody>
        );
      }
      let currentPage = this.state.pager.page;
      let totalPages = this.state.pager.pages_count;
      let previousButtonEnabled = this.state.pager.page > 1;
      let nextButtonEnabled = currentPage < totalPages;
      let totalItems = this.state.pager.total_items;
      let firstItem = this.state.pager.first_item;
      let lastItem = this.state.pager.last_item;
      let viewingText = "Página " + currentPage + " de " + totalPages + ". ";
      let currentResultsShowing = null;
      if (!this.state.loadingResults) {
        currentResultsShowing = "Mostrando los resultados " + firstItem + "-" + lastItem + " de " + totalItems;
      } else {
        currentResultsShowing = <span><i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando resultados...</span>;
      }
      viewingText = [viewingText, currentResultsShowing];
      let pager = (
        <Card className="card-plain">
          {/* <CardHeader>
            <CardTitle>

            </CardTitle>
          </CardHeader> */}
          <CardBody>
            <Row>
              <Col xs={3}>
                <Button
                  disabled={!previousButtonEnabled}
                  className="pager-page-button"
                  block
                  color="default"
                  size="sm"
                  onClick={() => {
                    let pager = this.state.pager;
                    pager.page = pager.page - 1;
                    this.setState({ pager: pager });
                    this.searchRouletteResults(pager);
                  }}
                >
                  Página anterior
                </Button>
              </Col>
              <Col xs={6}>
                <Row>
                  <Col xs={6}>
                    <Label md={12}>Resultados por página</Label>
                    <FormGroup xs={6}>
                      <Select
                        className="react-select primary"
                        classNamePrefix="react-select"
                        placeholder="Resultados"
                        name="resultados_por_pagina"
                        value={
                          this.state.pager
                            ? {
                                label: this.state.pager.items_per_page,
                                value: this.state.pager.items_per_page
                              }
                            : items_per_page_options[0]
                        }
                        options={items_per_page_options}
                        onChange={value => {
                          let pager = this.state.pager;
                          pager.items_per_page = value.value;
                          this.setState({ pager: pager });
                          this.searchRouletteResults(pager);
                        }}
                      />
                      <br></br>
                    </FormGroup>
                  </Col>
                  <Col>
                    <Label md={12}>Filtrar resultados</Label>
                    <Input
                      type="text"
                      placeholder="Filtro"
                      // onFocus={e => this.setState({ firstnameFocus: true })}
                      // onBlur={e => this.setState({ firstnameFocus: false })}
                      value={this.state.pager ? this.state.pager.query : ""}
                      onChange={(event) => {
                        let pager = this.state.pager;
                        pager.query = event.target.value;
                        this.setState({ pager: pager });
                        // this.searchRouletteResults(pager);
                      }}
                      onKeyDown={e => {
                        //console.log(e.keyCode);
                        if (e.keyCode == 13) {
                          //Enter is key code 13
                          this.searchRouletteResults();
                          // put the login here
                        }
                      }}
                    />
                  </Col>
                </Row>
                <Label md={12} className="text-center summup-pager">
                  {viewingText}
                </Label>
              </Col>
              <Col xs={3}>
                <Button
                  disabled={!nextButtonEnabled}
                  className="pager-page-button"
                  block
                  color="default"
                  size="sm"
                  onClick={e => {
                    // console.log("página siguiente", this.state.pager.page);
                    let pager = this.state.pager;
                    pager.page = pager.page + 1;
                    // console.log("La nueva", pager.page);
                    this.setState({ pager: pager });
                    this.searchRouletteResults(pager);
                  }}
                >
                  Página siguiente
                </Button>
              </Col>
            </Row>
          </CardBody>
        </Card>
      );
      return [pager, table];
    }
  }
  render() {
    let colSizes = {
      xs: 12,
      md: 6,
      lg: 4
    };
    let styleTitleIcon = {
      fontWeight: "bold",
      fontSize: "1.5em",
      display: "inline",
      position: "relative",
      bottom: "-9px",
      marginRight: "10px"
    };
    return (
      <div>
        <PanelHeader
          size="sm"
          content={
            <div>
              {/* <h6 style={dashboardOrdersTitleStyle}>Herramientas</h6> */}
            </div>
          }
        />
        <div className="content">
          <Row>
            <Col xs={12}>
              <Card className="text-center">
                <CardBody>
                  <CardTitle><div style={styleTitleIcon}><i style={{ maginBotton: "-3px" }} className="now-ui-icons design_bullet-list-67 icon icon-info"/></div> Lista de resultados</CardTitle>
                </CardBody>
              </Card>
            </Col>
            <Col>{this.buildResultsTable()}</Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default RouletteResults;



// WEBPACK FOOTER //
// ./src/views/Roulette/RouletteResults.jsx